import Block, { BlockTypes } from "./Block";
export default class Card {
    constructor(id, blocks) {
        this.hasName = false;
        this.description = [];
        this.id = id;
        this.blocks = [];
        let ignoreFurther = false;
        for (const block of blocks) {
            if (!ignoreFurther && block.getType() === BlockTypes.Header1 && !this.name) {
                this.name = block.getText().replace(/\# /, '');
                this.hasName = true;
            }
            else if (!ignoreFurther && block.getType() === BlockTypes.Synopsis) {
                this.description.push(block.getText().replace(/\=\s?/, ''));
            }
            else {
                if (block.getType() !== BlockTypes.Empty) {
                    ignoreFurther = true;
                }
                this.blocks.push(block);
            }
        }
        if (!this.name) {
            this.name = 'Unknown';
        }
    }
    getId() {
        return this.id;
    }
    getName() {
        return this.name;
    }
    getDescription() {
        return this.description.join("\n");
    }
    setName(name) {
        this.name = name;
        this.hasName = true;
    }
    setDescription(description) {
        this.description = description.split(/\r?\n/);
    }
    getAsBlocks(idManager) {
        const blocks = [];
        if (this.hasName) {
            blocks.push(new Block(idManager.getNextId(), BlockTypes.Header1, '# ' + this.name));
        }
        if (this.description.length > 1 || (this.description.length === 1 && this.description[0] !== '')) {
            this.description.forEach((description) => {
                if (description === '') {
                    blocks.push(new Block(idManager.getNextId(), BlockTypes.Empty, ''));
                }
                else {
                    blocks.push(new Block(idManager.getNextId(), BlockTypes.Synopsis, '= ' + description));
                }
            });
        }
        this.blocks.forEach((block) => {
            if (block.getType() !== BlockTypes.Header1 && block.getType() !== BlockTypes.Synopsis) {
                blocks.push(block);
            }
        });
        return blocks;
    }
    getBlockCount() {
        return this.blocks.length;
    }
}
export function getCards(blocks, idManager) {
    const cards = [];
    let blocksForCard = [];
    for (const block of blocks) {
        if (block.getType() === BlockTypes.Header1) {
            if (blocksForCard.length > 0) {
                cards.push(new Card(idManager.getNextId(), blocksForCard));
                blocksForCard = [];
            }
        }
        blocksForCard.push(block);
    }
    if (blocksForCard.length > 0) {
        cards.push(new Card(idManager.getNextId(), blocksForCard));
    }
    return cards;
}
